import { Redirectable } from "kinnect-mixins";
import {
	VBtn,
	VCard,
	VCardActions,
	VCardText,
	VCardTitle,
	VDialog,
	VSpacer
} from "vuetify/lib";

export default VDialog.extend( {
	name: "KActionDialog",

	mixins: [ Redirectable ],

	props: {
		confirmButtonColor: String,

		confirmButtonText: String,

		disabled: Boolean,

		fullWidth: {
			...VDialog.options.props.fullWidth,
			default: true
		},

		loading: Boolean,

		maxWidth: {
			...VDialog.options.props.maxWidth,
			default: 290
		},

		title: String
	},

	methods: {
		onConfirm() {
			if ( typeof this.$listeners.confirm === "function" ) {
				this.$listeners.confirm().then( () => {
					this.isActive = false;
					this.doRedirect();
				} );
			} else {
				this.isActive = false;
				this.doRedirect();
			}
		},

		getContentSlot() {
			return [
				<VCard>
					<VCardTitle>{this.title}</VCardTitle>

					<VCardText>{VDialog.options.methods.getContentSlot.call( this )}</VCardText>

					<VCardActions>
						{this.$slots.actions
							? this.$slots.actions
							: [
								<VSpacer></VSpacer>,

								!this.loading && <VBtn
									onClick={() => this.isActive = false}
									text
								>Cancel</VBtn>,

								<VBtn
									color={this.confirmButtonColor}
									disabled={this.disabled}
									loading={this.loading}
									onClick={this.onConfirm}
									text
								>{this.confirmButtonText}</VBtn>
							]
						}
					</VCardActions>
				</VCard>
			];
		}
	}
} );
